import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { AlertTriangle, X, Trash2 } from 'lucide-react';
import { AnimatedIconButton } from './AnimatedIconButton';
import { useLanguage } from '../../contexts/LanguageContext';

interface ClearGalleryConfirmModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

export function ClearGalleryConfirmModal({ onClose, onConfirm }: ClearGalleryConfirmModalProps) {
  const { t } = useLanguage();
  
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-md backdrop-blur-sm" style={{ backgroundColor: 'rgba(var(--color-background-rgb, 255, 255, 255), 0.9)' }}>
        <DialogTitle className="sr-only">{t.confirm.clearGalleryTitle}</DialogTitle>
        <DialogDescription className="sr-only">
          {t.confirm.clearGalleryDescription}
        </DialogDescription>
        
        <div className="flex flex-col items-center gap-4 py-6 px-6">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-danger-light)' }}>
            <AlertTriangle className="w-6 h-6" style={{ color: 'var(--color-danger)' }} />
          </div>
          
          <div className="text-center">
            <h3 className="mb-2" style={{ color: 'var(--color-text-primary)' }}>
              {t.confirm.clearGalleryQuestion}
            </h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              {t.confirm.clearGalleryWarning}
              <br />
              {t.confirm.irreversible}
            </p>
          </div>
          
          <div className="flex gap-3 justify-center mt-2">
            <AnimatedIconButton
              icon={X}
              label={t.confirm.cancel}
              onClick={onClose}
              variant="neutral"
              revealLabelOnHover={false}
            />
            <AnimatedIconButton
              icon={Trash2}
              label={t.confirm.clearGallery}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              variant="danger"
              revealLabelOnHover={false}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}